import { AjaxFormModal, AjaxFormContent, Confirm } from 'sma.common/components/modals';
import { Strength, PasswordEye } from 'sma.common/strength';
import { ImageCropper } from 'sma.common/components/image_uploader';
import { Grid } from 'sma.admin/components/grid';
import Backbone from 'backbone';

const ajax = require('sma.common/ajax');
const Alert = require('sma.admin/components/alert');
const formError = require('sma.common/formErrors.js');
const DatePicker = require('sma.admin/components/datepicker');

const profilePictureTempl = require('sma.accounts/partials/profile_picture.mustache');
const tempEmailTempl = require('sma.accounts/partials/temp_email.mustache');
const initialGroupTempl = require('sma.admin/awards/manage/partials/initial_group.mustache');

const { cancelAccountDeletionDialog, accountDeleteDialog } = require('sma.common/gdpr');

const STRINGS = {
	profile_picture: gettext('Profile picture'),
	remove_photo: gettext('Remove photo'),
	upload_photo: gettext('Upload a photo'),
	upload_new_photo: gettext('Upload a new photo'),
	cancel_change: gettext('Cancel this change'),
	resend: gettext('Resend confirmation'),

	upload_picture: gettext('Upload profile picture'),
	applicant: gettext('Applicant'),
	reason: gettext('Reason'),
	date_made: gettext('Date made'),
	delete_conflict: gettext('Remove conflict of interest'),
	delete_conflict_confirm: gettext('Are you sure you want to remove this conflict of interest?'),

	cancelDeletionConfirmation: gettext(
		'Are you sure you want to cancel your delete account request? Site administrators will be notified that no further action is required'
	),
	invalidPassword: gettext('The password entered is not the correct password for the account'),
};

let conflictColumns = [
	{
		name: STRINGS.applicant,
		id: 'applicant',
		formatter: function(item) {
			return initialGroupTempl({
				top: item.applicant.full_name,
				bottom: item.applicant.email,
			});
		},
	},
	{
		name: STRINGS.reason,
		id: 'reason',
	},
	{
		name: STRINGS.date_made,
		id: 'created_at',
	},
	{
		name: '',
		id: 'delete',
		formatter: function(item) {
			return `<a href="#" class="sma-hideable-menu sma-js-delete-conflict" data-id=${item.id} \
				data-applicant_first=${item.applicant.first_name} data-applicant_last=${item.applicant.last_name}><i class="nc-icon-mini ui-1_trash-simple"></i></a>`
		},
	},
];

let ConflictsGrid = Grid.extend({
	showTitlebar: false,
	showSearchBar: false,
	showColumnDropSelect: false,
	showPagination: false,
	loaderSize: 'md',
	columns: conflictColumns,
	showSelectorColumn: false,
	rowClass: 'sma-menu-container',

	onLoad(resonse) {
		$('.sma-js-delete-conflict').click((e) => {
			e.preventDefault();
			let conflictId = $(e.currentTarget).data('id');
			let applicantFirstName = $(e.currentTarget).data('applicant_first');
			let applicantLastName = $(e.currentTarget).data('applicant_last');

			let delete_conflict_confirm = interpolate(
				gettext('Removing this conflict of interest will allow you to review applications from this \
					applicant in the future.<br><br><strong>Applicant:</strong> %(applicantFirstName)s %(applicantLastName)s'),
				{applicantFirstName, applicantLastName}, true
			);

			let modal = new Confirm(STRINGS.delete_conflict, delete_conflict_confirm, () => {
				let url = reverse('reviewer-conflict-delete', {
					conflict_id: conflictId,
				});

				ajax.post({
					url: url,
					callback: $.proxy(function() {
						this.load();
					}, this),
				});
			});
		});
	},
});

function accountDeletionRequest(password, callback) {
	$('.sma-js-delete-dialog-delete-button')
		.addClass('disabled')
		.attr('disabled', 'disabled');

	$.post(
		reverse('admin-account-delete-request'),
		JSON.stringify({
			password: password,
		}),
		(response) => {
			$('.sma-js-delete-dialog-delete-button')
				.removeClass('disabled')
				.removeAttr('disabled');
			callback(response);
		},
		'json'
	);
}

export class Account extends Backbone.View {
	constructor(config) {
		super();

		this.setElement('body');

		let context = config;
		context.strings = STRINGS;

		this.sites = config.sites;
		this.role = config.role;
		this.gdpr_delay = parseInt(config.gdpr_delay);

		this.toggleTempEmailDisplay(config);
		this.setProfilePicture(config);

		this.deletionInfo = config.deletionInfo !== undefined ? config.deletionInfo : {};

		let imageUploaderConfig = {
			wrapper: $('#profile-picture-container'),
			inputField: '.sma-js-img-upload-field',
			onCropHandler: (croppedImg) => {
				let data = {
					strings: STRINGS,
					picture: croppedImg,
				};

				this.setProfilePicture(data);
				$('#sma-hidden-profile-img').val(croppedImg);
				this.addProfilePicture();
			},
		};

		new ImageCropper(imageUploaderConfig);

		new Strength({
			element: $('#id_password'),
			confirm: $('#id_password_confirmation'),
		});

		new PasswordEye($('#id_password_old'));

		$('.sma-js-date-picker').each(function() {
			new DatePicker($(this));
		});

		if (this.role === 'reviewer') {
			this.renderConflictsTable();
		}

		if (window.location.hash) {
			$('a[data-toggle="tab"][href="' + window.location.hash + '"]').click();
		}
	}

	get events() {
		return {
			'click .sma-js-account-disconnect': 'disconnectSocial',
			'click #remove_picture': 'removeProfilePicture',
			'click #save-settings': 'submitSettings',
			'click #generate-new-api-tokens': 'submitApiTokens',
			'click #save-password': 'submitPassword',
			'click #save-notifications': 'submitNotifications',
			'click #cancel_change': 'cancelEmailChange',
			'click #resend_confirmation': 'resendConfirmation',
			'click #sma-js-become-applicant': 'becomeApplicant',
			'click .sma-applicant-tab-item': 'navDropdownItemClicked',
		};
	}

	navDropdownItemClicked(e) {
		e.preventDefault();
		$(e.currentTarget).tab('show');
	}

	setProfilePicture(data) {
		let content = profilePictureTempl(data);
		$("#profile-picture-container").html(content);
		window.localize(); // To translate the file widget
	}

	toggleTempEmailDisplay(context) {
		if (context && context.temp_email) {
			var email = context.temp_email
		}

		let tempEmailDiv = $('.sma-js-temp-email');

		if (email) {
			var context = STRINGS;

			context.temp_email = interpolate(
				gettext('Check your email %(email)s to confirm your new email address. \
					Until you confirm, notifications will continue to be sent to your current email address.'),
				{email}, true
			);
			
			var content = tempEmailTempl({'strings': context, 'temp_email': email});

			tempEmailDiv.html(content);		
		} else {
			tempEmailDiv.html('');
		}
	}

	disconnectSocial(e) {
		let modal = new AjaxFormModal({
			title: gettext('Disconnect your social account'),
			subtitle: gettext('In order to disconnect from your social profile, we require \
				a password to be created so you can continue to access this account.'),
			destroyOnClose: true,
		});

		modal.addToStack(
			'DisconnectSocialAccount',
			new AjaxFormContent(
				reverse('disconnect-social-login'),
				{
					onLoad: () => {
						new Strength({
							element: $('#id_password'),
							confirm: $('#id_password_confirmation'),
						});
						modal.show();
					}
				},
			),
		);
	}

	addProfilePicture() {
		let form = $('#sma-profile-picture-form')[0];
		let data = new FormData(form);

		let options = {
			url: reverse('add-profile-picture'),
			data: data,
			cache: false,
			datatype: 'json',
			processData: false,
			contentType: false,
			alertOnSuccess: true,
		};

		ajax.post(options);
	}

	removeProfilePicture(e) {
		e.preventDefault();
		ajax.post({
			url: reverse('remove-profile-picture'),
			callback: (result) => {
				result.strings = STRINGS;
				this.setProfilePicture(result);
			},
		});
	}

	submitForm(href, form, callback) {
		let data = new FormData(form);

		let options = {
			url: href,
			data: data,
			cache: false,
			datatype: 'json',
			processData: false,
			contentType: false,
			alwaysCallback: true,
			callback: (result) => {
				let elem = $(form);
				if (result.errors) {
					formError.removeErrors(elem);
					formError.addErrors(elem, result.errors);
				} else {
					formError.removeErrors(elem);
					if (callback) {
						callback(result);
					}
				}
			},
		};
		ajax.post(options);
	}

	submitPassword(e) {
		e.preventDefault();
		var target = $(e.currentTarget);
		var href = target.attr('href');
		var form = $('#sma-account-password-form')[0];
		let callback = function () {
			form.reset();
		};

		this.submitForm(href, form, callback);
	}

	submitNotifications(e) {
		e.preventDefault();
		let target = $(e.currentTarget);
		let href = target.attr('href');
		let form = $('#sma-account-notification-form')[0];

		this.submitForm(href, form);
	}

	submitSettings(e) {
		e.preventDefault();
		let target = $(e.currentTarget);
		let href = target.attr('href');

		let form = $('#sma-account-settings-form')[0];

		let callback = (data) => {
			this.toggleTempEmailDisplay(data);
			data.strings = STRINGS;
			this.setProfilePicture(data);
		};
		this.submitForm(href, form, callback);
	}

	submitApiTokens(e) {
		e.preventDefault();
		let target = $(e.currentTarget);
		let href = target.attr('href');
		let form = $('#sma-api-tokens-form')[0];
		let callback = (data) => {
			$('#sma-js-api').removeClass('d-none');
			$('#sma-js-api-client-id').text(data.clientId);
			$('#sma-js-api-client-secret').text(data.clientSecret);
			$('#sma-js-api-refresh-token').text(data.refreshToken);
			$('#sma-js-api-access-token').text(data.accessToken);
			$('#sma-js-api-scope').text(data.scope);
		};
		this.submitForm(href, form, callback);
	}

	cancelEmailChange(e) {
		e.preventDefault();

		let options = {
			url: reverse('cancel-email-change'),
			callback: (result) => {
				this.toggleTempEmailDisplay();
			},
		};
		ajax.post(options);
	}

	resendConfirmation(e) {
		e.preventDefault();

		let options = {
			url: reverse('resend-email-confirmation'),
			data: {
				role: this.role,
			},
		};

		ajax.post(options);
	}

	becomeApplicant(e) {
		e.preventDefault();

		let options = {
			url: reverse('accounts-become-applicant'),
			callback: (result) => {
				$(e.currentTarget).parent().remove();
			}
		};

		ajax.post(options);
	}

	renderConflictsTable() {
		let url = reverse('reviewer-conflict-list');
		
		this.conflictsGrid = new ConflictsGrid({
			element: $('#conflicts-table'),
			url: url,
		});
	}
}

export class CancelDeleteAccount extends Backbone.View {
	constructor(config) {
		super();

		this.setElement('body');
	}

	get events() {
		return {
			'click .sma-js-account-cancel-delete': 'cancelDeleteAccount',
		};
	}

	cancelDeleteAccount(e) {
		e.preventDefault();

		cancelAccountDeletionDialog({
			title: gettext('Cancel account deletion'),
			strings: STRINGS,
			deletionInfo: this.deletionInfo,
			handler(modal) {
				$('#sma-js-cancel-account-deletion').addClass('disabled').attr('disabled', 'disabled');

				$.post(
					reverse('admin-account-delete-request-cancel'),
					{},
					(response) => {
						$('#sma-js-cancel-account-deletion').removeClass('disabled').removeAttr('disabled');
						if (response.success) {
							modal.hide();
							window.location.reload();
						}
					},
					'json'
				);
			}
		});
	}
}

export class NotificationPreferences {
	constructor() {
		let disableChecks = function($sel) {
			$sel.prop('disabled', true);
			$sel.prop('checked', false);
		};

		let enableChecks = function($sel) {
			$sel.removeAttr('disabled');
		};

		$(function() {
			let $notificationForm = $('#sma-account-notification-form');
			let $notifications = $notificationForm.find('.sma-js-notification-field input');
			let $unsubscribe_from_all = $notificationForm.find('.sma-js-unsubscribe-from-all input');

			if ($unsubscribe_from_all[0].checked) {
				disableChecks($notifications);
			}

			$unsubscribe_from_all.on('click', (e) => {
				if ($unsubscribe_from_all[0].checked) {
					disableChecks($notifications);
				} else {
					enableChecks($notifications);
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ../apps/chide/products/smapply/static/sma.accounts/account.js